import _default from './Grid';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/collections/Grid/index.js
// module id = 2692
// module chunks = 1